export default "__VITE_ASSET__DjkWwnTo__"